// 判断环境,是否安卓,苹果,微信,APP内外
// https://wiki.didapinche.com/index.php?title=User-Agent_定义
function getEnv() {
  var option, userAgent;
  userAgent = window.navigator.userAgent; // DidaPinche/8.13.5

  option = {
    inApplication: userAgent.indexOf('DidaPinche') !== -1,
    inWechat: userAgent.indexOf('MicroMessenger') !== -1,
    isiPhone: userAgent.indexOf('iPhone') !== -1,
    isAlipay: userAgent.indexOf('Alipay') !== -1,
    isAndroid: userAgent.indexOf('Android') !== -1,
    isDidaPinche: false,
    isDidaTaxi: false
  };
  var versionRes = userAgent.match(/DidaPinche\/(\d+\.\d+\.\d+)/);

  if (versionRes) {
    option['curAppVersion'] = versionRes[1]; // 版本
  } // 线上环境


  option.isEnvOnline = /(www|static|m|web)\.(didapinche|didachuxing|didacar|dida-pinche|didataxi)\.com/.test(window.location.href); // 阿里云环境

  option.isEnvECS = /(www-ecs|web-ecs|web-simu)\.(didapinche|didachuxing|didacar|dida-pinche|didataxi)\.com/.test(window.location.href); // 测试环境

  option.isEnvTest = !option.isEnvOnline && !option.isEnvECS;

  if (option.inApplication) {
    // 区分App(出行端和司机端)
    if (userAgent.indexOf('[App]') > -1) {
      option.isDidaPinche = true;
    } else {
      option.isDidaTaxi = true;
    }
  }

  return option;
}

var Env = getEnv();
console.log('Env', JSON.stringify(Env));
export default Env; // 判断版本号
// v1 > v2 ==> 1
// v1 < v2 ==> -1
// v1 == v2 ==> 0

export function compareVersion(v1, v2) {
  v1 = v1.split('.');
  v2 = v2.split('.');
  var len = Math.max(v1.length, v2.length);

  while (v1.length < len) {
    v1.push('0');
  }

  while (v2.length < len) {
    v2.push('0');
  }

  for (var i = 0; i < len; i++) {
    var num1 = parseInt(v1[i], 10);
    var num2 = parseInt(v2[i], 10);

    if (num1 > num2) {
      return 1;
    } else if (num1 < num2) {
      return -1;
    }
  }

  return 0;
}